import React, { ReactNode } from "react";

export const Modal = React.memo(function Modal(props: Props) {
    const { open, onRequestClose, children } = props;

    if (!open) return null;

    return (
        <div className={"modal_overlay"} onClick={onRequestClose}>
            {children}
        </div>
    );
});

type Props = {
    open: boolean,
    onRequestClose?: () => void,
    children?: ReactNode,
};
